import React from 'react';

export type TabSelectorTab = {
  key: string | number;
  label: string;
  badge?: number;
  dataCy?: string;
};

type TabSelectorProps = {
  tabs: Array<TabSelectorTab>;
  activeKey: string | number;
  onChange: (key: any) => void;
  className?: string;
};

export const TabSelector = ({
  tabs, activeKey, onChange, className,
}: TabSelectorProps) => (
  <div
    className={`inline-flex w-full ${className || ''}`}
    style={{
      background: '#CDC4D6',
      borderRadius: 100,
      padding: 2,
    }}
    role="tablist"
  >
    {tabs.map((tab) => {
      const isActive = tab.key === activeKey;
      return (
        <button
          key={String(tab.key)}
          type="button"
          role="tab"
          aria-selected={isActive}
          data-cy={tab.dataCy}
          onClick={() => onChange(tab.key)}
          className="flex-1 flex items-center justify-center gap-2 transition-colors"
          style={{
            background: isActive ? '#F7F5F8' : 'transparent',
            borderRadius: 100,
            padding: '12px 16px',
            color: '#39264F',
            fontFamily: 'Grift, sans-serif',
            fontWeight: 700,
            fontSize: 15,
            letterSpacing: '0.5px',
            lineHeight: '17px',
            boxShadow: isActive ? '0 1px 4px 0 rgba(24, 0, 100, 0.12)' : 'none',
          }}
        >
          <span>{tab.label}</span>
          {tab.badge != null && tab.badge > 0 && (
            <span
              aria-label={`${tab.badge} pending`}
              className="inline-flex items-center justify-center text-white"
              style={{
                width: 20,
                height: 20,
                fontSize: 11,
                fontWeight: 700,
                background: '#AB72ED',
                borderRadius: 100,
              }}
            >
              {tab.badge}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default TabSelector;
